module.exports = __webpack_public_path__ + "static/media/fabio-mangione.f26c34bb.jpg";